import React from 'react';
import './calendar.scss';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
// @ts-ignore
import plLocale from '@fullcalendar/core/locales/pl.js';
import moment from 'moment';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';

import "bootstrap/dist/css/bootstrap.min.css";
import Course from '../../objects/Course';
import Event from '../../objects/Event';

interface CalendarProps {
    events: Event[];
    courses: Course[];
    handler: any;
}

export class CalendarScheduler extends React.Component<CalendarProps, any>
{
    render() {
        const { events, handler } = this.props;

        return <FullCalendar
            defaultView="dayGridMonth"
            plugins={[dayGridPlugin]}
            timeZone={'Europe/Warsaw'}
            events={this.parseEvents()}
            locales={[plLocale]}
            locale={plLocale}
            height={800}
            eventClick={(e) => { handler(e.event.extendedProps.course, e.event.extendedProps.event_date) }}
        />
    }

    parseEvents = (): any => {
        let events_list: Array<any> = [];
        this.props.events.forEach((event: any) => {
            //hide same day hour events
            let tmp = events_list.filter((e: any) => event.course_id == e.course && e.event_date == moment.unix(event.start_time).format("YYYY-MM-DD"));
            if(tmp.length == 0) {
                events_list.push({
                    id: event.id,
                    title: this.getCourseName(event.course_id),
                    date: moment.unix(event.start_time).format("YYYY-MM-DD"),
                    course: event.course_id,
                    event_date: moment.unix(event.start_time).format("YYYY-MM-DD")
                })
            }
        });

        return events_list;
    }

    getCourseName = (courseId: number): string => {
        let cname;

        this.props.courses.forEach((course: any) => {
            if (course.id == courseId) {
                cname = course.course;
            }
        })
        return cname ?? "NO_NAME";
    }
}
